import Vue from "vue";
import iView from "iview";
import Clipboard from "clipboard";

let aips = "";
let token = "";
let getParam = function getParam() {
  var search = {};
  try {
    location.search
      .substr(1)
      .split("&")
      .forEach(function(item) {
        var s = item.split("=");
        search[s[0]] = s[1];
      });
  } catch (e) {
    // 抛出异常
    throw new Error(JSON.stringify(search));
  }
  return search;
};
let ispc = function ispc() {
  return !/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent);
};
if (location.href.indexOf(":80") != -1) {
  aips = "/apis";
}
// 投审稿作者端地址
let getAuthorUrl = () => {
  let url = "";
  if (
    location.host.indexOf("cbtest.") != -1 ||
    location.host.indexOf(":80") != -1 ||
    location.host.indexOf("localhost") != -1
  ) {
    url = "https://tsgauthortest.baikezaixian.com/tsg-author"; // 投审稿作者端测试环境
  } else if (location.host.indexOf("yucard") != -1) {
    url = "https://tsgauthoryu.cnknowledge.com/tsg-author"; // 投审稿作者端预生产环境
  } else {
    url = "https://tsgauthor.cnknowledge.com/tsg-author"; // 投审稿作者端正式环境
  }
  return url;
};

// 投审稿后台管理地址
// 投审稿后台接口地址
let getTsgAdminUrl = () => {
  let url = "";
  if (
    location.host.indexOf("cbtest.") != -1 ||
    location.host.indexOf("127.") != -1 ||
    location.host.indexOf("localhost") != -1
  ) {
    url = "https://tsgadmintest.cnknowledge.com/tsg-admin"; // 投审稿测试环境
  } else if (location.host.indexOf("yucard") != -1) {
    url = "https://tsgadminyu.cnknowledge.com/tsg-admin"; // 投审稿预生产环境
  } else {
    url = "https://tsgadmin.cnknowledge.com/tsg-admin"; // 投审稿正式环境
  }
  return url;
};
// 图片地址
let getImgUrl = () => {
  let url = "";
  if (
    location.host.indexOf("cbtest.") != -1 ||
    location.host.indexOf(":80") != -1 ||
    location.host.indexOf("localhost") != -1
  ) {
    url = "https://fdfs.cnknowledge.com/"; // 图片测试环境
  } else if (location.host.indexOf("yucard") != -1) {
    url = "https://ljw.cnknowledge.com/"; // 图片预生产环境
  } else {
    url = "https://kpp.cnknowledge.com/"; // 图片正式环境
  }
  return url;
};
var global = {
  url: getAuthorUrl(),
  tsgAdminUrl:getTsgAdminUrl(),
  url2: "https://web.tonghangpingyi.com/txpy-web",
  imgUrl: getImgUrl(),
  // 测试使用
  ispc: ispc(),
  publishPeriod(num) {
    let data = [
      { name: "年刊" },
      { name: "半年刊" },
      { name: "季刊" },
      { name: "双月刊" },
      { name: "月刊" },
      { name: "半月刊" },
      { name: "旬刊" },
      { name: "周刊" },
      { name: "周二刊" },
    ];
    if (num == "") {
      return;
    }
    return num ? data[num - 1].name : data[0].name;
  },
  isPCs() {
    return !/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent);
  },
  getParam: getParam, // 获取url参数返回json
  transferDate(times) {
    //时间戳转时间
    var date = new Date(times);
    var Y = date.getFullYear() + "-";
    var M =
      (date.getMonth() + 1 < 10
        ? "0" + (date.getMonth() + 1)
        : date.getMonth() + 1) + "-";
    var D = (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
    var h =
      (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
    var m =
      (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
      ":";
    var s =
      date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
    return Y + M + D + h + m + s;
  },
  transferYear(times) {
    //时间戳转时间年月日
    var date = new Date(times);
    var Y = date.getFullYear() + "-";
    var M =
      (date.getMonth() + 1 < 10
        ? "0" + (date.getMonth() + 1)
        : date.getMonth() + 1) + "-";
    var D = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
    return Y + M + D;
  },
  transferTime(times) {
    //时间转时间戳
    return new Date(times).getTime();
  },
  copyArr(arr) {
    //拷贝数组
    return Object.assign([], arr);
  },
  copyObj(obj) {
    //拷贝对象
    return Object.assign({}, obj);
  },
  //深拷贝
  deepClone(obj) {
    let _tmp = JSON.stringify(obj); //将对象转换为json字符串形式
    let result = JSON.parse(_tmp); //将转换而来的字符串转换为原生js对象
    return result;
  },
  copy(mobile) {
    var Url = mobile;
    var clipboard = new Clipboard(".tag-read", {
      text: function() {
        return Url;
      },
    });
    clipboard.on("success", (e) => {
      iView.Message.success("复制成功");
      // 释放内存
      clipboard.destroy();
    });
    clipboard.on("error", (e) => {
      // 不支持复制
      iView.Message.warning("该浏览器不支持自动复制");
      // 释放内存
      clipboard.destroy();
    });
  },
  sortByKey(array, key) {
    //(数组、排序的列)
    return array.sort(function(a, b) {
      var x = a[key];
      var y = b[key];
      return x < y ? -1 : x > y ? 1 : 0;
    });
  },
  //职称
  gradess(status) {
    if (status == "senior") {
      return "1";
    } else if (status == "subSenior") {
      return "2";
    } else if (status == "middle") {
      return "3";
    } else if (status == "elementary") {
      return "4";
    }
  },
};

// 注册插件全局通用
export default {
  install() {
    Vue.prototype.$global = global;
  },
  global,
};
